import React from 'react';
import {AppContext} from '../../../AppModule/Context';

import AnimatedSvgLogo from '../../common/genericComponents/animatedSvgLogo';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import PhoneNumberInput from '../../common/genericComponents/phoneNumberInput';
import WidgetTitleComponent from './widgetTitleComponent';

import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';
import phone from '../../../assets/svg/phone-redesign.svg';

import './phoneCallComponent.css';

class PhoneCallComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = () => {
    const isMobileDevice = utilsService.isMobileDevice(); //todomcss : ok
    this.setState({
      publicPhoneNumber: this.props.mentor.mentorDto.publicPhoneNumber,
      isMobileDevice,
    });
  };

  makePhoneCall = () => {
    this.props.sendGA(VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.PHONE_CALL);
    this.props.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.PHONE_CALL,
    );
    let publicPhoneNumber = this.props.mentor.mentorDto.publicPhoneNumber;
    if (publicPhoneNumber && publicPhoneNumber[0] !== '+') {
      publicPhoneNumber = '+' + publicPhoneNumber;
    }
    if (this.state.isMobileDevice) {
      window.open('tel:' + publicPhoneNumber);
    } else {
      this.setState({
        publicPhoneNumber: publicPhoneNumber,
      });
    }
  };

  render() {
    const {isPersonalPage, showNewUI} = this.props;
    const tabInnerText =
      this.props.mentor.mentorDto.appControlDto.widgetEditableTexts &&
      this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL
      ]
        ? this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL
          ]
        : 'Want to hear my voice?';

    return (
      <div
        className={
          isPersonalPage
            ? 'et-personal-page-right-content-wrap'
            : 'et-widget-body-content-wrap'
        }>
        <div
          className={`et-v2-phone-call-container ${isPersonalPage ? 'et-v2-pp-phone-call-container' : ''}`}>
          {!isPersonalPage && <WidgetTitleComponent title={tabInnerText} />}
          <div
            className="et-v2-phone-call-icon-number-wrap"
            onClick={() => {
              this.makePhoneCall();
              this.props.callSendMessageFunc(
                'Phone call',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.PHONE_MESSAGE,
              );
            }}>
            {showNewUI ? (
              <div className="et-v2-phone-call-animated-svg-logo-wrap">
                <AnimatedSvgLogo
                  type={VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.PHONE_CALL}
                />
              </div>
            ) : (
              <img
                className="et-v2-phone-call-img"
                src={phone}
                alt="phone-icon"
              />
            )}
            {isPersonalPage && (
              <div className="et-v2-phone-call-inner-txt">{tabInnerText}</div>
            )}
            <div className="et-v2-widget-phone-input-wrap">
              <PhoneNumberInput
                value={this.state.publicPhoneNumber}
                variant={'text-label'}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div
          className={`et-v2-widget-btn-wrap  ${isPersonalPage ? 'et-v2-clickntalk-btn-wrap' : ''}`}>
          <ButtonComponent
            onClick={() => {
              this.makePhoneCall();
              this.props.callSendMessageFunc(
                'Phone call',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.PHONE_MESSAGE,
              );
            }}
            image={
              isPersonalPage ? (
                <div className="et-v2-phone-call-btn-img">
                  <CommunicationIcons.PhoneIcon fillColor="#fff" size={35} />
                </div>
              ) : null
            }
            text={
              this.props.mentor.mentorDto.appControlDto.widgetEditableTexts &&
              this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
                VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT.PHONE_CALL
              ]
                ? this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
                    VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT.PHONE_CALL
                  ]
                : this.context.languageSet.VIDEO_CALL_CAT.CALL_NOW
            }
          />
        </div>
      </div>
    );
  }
}

PhoneCallComponent.contextType = AppContext;
export default PhoneCallComponent;
